<template>
  <v-row justify="center">
    <v-dialog v-model="isOpen" scrollable persistent width="750px">
      <v-form
        class="article"
        ref="form"
        v-model="valid"
        v-on:submit.prevent="validate"
      >
        <v-card>
          <v-toolbar flat dark color="rgb(51, 97, 137)">
            <v-toolbar-title>
              <v-icon left>mdi-format-float-left</v-icon
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertArticle.addEditArticle'
                )
              }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  icon
                  dark
                  :disabled="loading"
                  @click="closeDialogQuestion"
                  v-on="on"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span class="subtitle-1">{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.close'
                )
              }}</span>
            </v-tooltip>
          </v-toolbar>

          <v-card-text>
            <v-row>
              <v-col>
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertArticle.articleName'
                    )
                  }}
                  <span class="red--text">*</span>
                </p>
                <v-text-field
                  outlined
                  v-model="title"
                  :rules="nameRules"
                  :placeholder="
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertArticle.articleName'
                    )
                  "
                  required
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <p class="title">
                  {{
                    $vuetify.lang.t(
                      '$vuetify.courseManagement.lectureStep.insertExam.insertArticle.question'
                    )
                  }}
                  <span class="red--text">*</span>
                </p>
                <quill-editor
                  class="editor"
                  v-model="article"
                  :rules="articleRules"
                  ref="article"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              elevation="0"
              class="px-9 ma-2 subtitle-2 button-secondary font-weight-light text-capitalize"
              outlined
              :disabled="loading"
              @click="closeDialogQuestion"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.cancel'
                )
              }}</v-btn
            >
            <v-btn
              elevation="0"
              class="px-10 ma-2 subtitle-2 text-capitalize font-weight-light button-primary"
              @click="validate"
              :disabled="!valid || article == '' || loading"
              :loading="loading"
              >{{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertExam.save'
                )
              }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="dialogSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertArticle.saveDone'
          )
        }}</v-card-title>

        <v-card-text>{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertArticle.saveDoneDetail'
          )
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialogSuccess = false">{{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.insertExam.done'
            )
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="warnningToSaveDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.alertLeavePageTitle'
            )
          }}
        </v-card-title>
        <v-card-text>
          {{
            $vuetify.lang.t(
              '$vuetify.courseManagement.lectureStep.alertLeavePageSubTitle'
            )
          }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-capitalize"
            color="white"
            @click="warnningToSaveDialog = false"
          >
            <p class="mb-0">
              {{
                $vuetify.lang.t(
                  '$vuetify.courseManagement.lectureStep.insertYoutube.continue'
                )
              }}
            </p>
          </v-btn>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="confirmCloseDialog()"
          >
            <p class="mb-0">
              {{
                $vuetify.lang.t('$vuetify.courseManagement.lectureStep.exit')
              }}
            </p>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSaveFail" persistent max-width="450" color="white">
      <v-card class="pa-3">
        <v-card-title class="mb-3">{{
          $vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.savingFailed'
          )
        }}</v-card-title>
        <v-card-text>
          <p class="subtitle-1">
            {{
              $vuetify.lang.t(
                '$vuetify.courseManagement.lectureStep.insertExam.saveFailMsg'
              )
            }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            elevation="0"
            class="mb-0 body-2 text-primary text-capitalize"
            color="white"
            @click="dialogSaveFail = false"
            >{{
              $vuetify.lang.t('$vuetify.courseManagement.lectureStep.confirm')
            }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import {
  insertQuestion,
  getQuestionById,
  updateQuestion,
} from '@/service/course/exam';
export default {
  props: {
    // isLectureOpen: {
    //   type: Boolean
    // },
    // isOpen: {
    //   type: Boolean
    // },
    // examId: {
    //   type: String
    // },
    // questionId: {
    //   type: String
    // },
    // questionType: {
    //   type: String
    // },
    // questions: {},
    // lectureId: {
    //   type: String
    // },
    // lectures: {
    //   type: Array
    // },
    // sectionId: {
    //   type: String
    // },
    // reorderLecture: {
    //   type: Function
    // },
    // closeDialog: {
    //   type: Function
    // },
    // closeExamDialog: {
    //   type: Function
    // }
    isLectureOpen: {
      type: Boolean,
    },
    isOpen: {
      type: Boolean,
    },
    examId: {
      type: String,
    },
    questionId: {
      type: String,
    },
    questionType: {
      type: String,
    },
    questions: {},
    articleId: {
      type: String,
    },
    lectureId: {
      type: String,
    },
    lectures: {
      type: Array,
    },
    sectionId: {
      type: String,
    },
    reorderLecture: {
      type: Function,
    },
    closeDialog: {
      type: Function,
    },
  },
  data() {
    return {
      valid: false,
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      question: '',
      title: '',
      article: '',
      articleRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertArticle.articleRules'
          ),
      ],
      question_score: '',
      answer: [],
      answer_description: '',
      nameRules: [
        (v) =>
          !!v ||
          this.$vuetify.lang.t(
            '$vuetify.courseManagement.lectureStep.insertExam.insertArticle.scoreRules1'
          ),
      ],
      rows: [1],
      chars: [],
      answer_select: [],
      answer_correct: 0,
      dialogSuccess: false,
      loading: false,
      warnningToSaveDialog: false,
      dialogSaveFail: false,
    };
  },
  watch: {
    isOpen: async function (newValue) {
      if (newValue) {
        if (this.questionId) {
          // let filterQuestion = this.questions.filter(
          //   question => question._id === this.questionId
          // )[0];
          // console.log(filterQuestion)
          let result = await getQuestionById({ id: this.questionId });
          this.oldQuestion = result;
          this.title = result.question;
          this.article = result.article;
          // this.question = result.question;
          // this.question_score = result.score;
          // this.answer = result.choices;
          // this.answer_description = result.note;
          // // this.answer_select = result.choices.map( choice=> choice._id === )
          // this.answer_correct = result.correct.map(correct =>
          //   result.choices.findIndex(choices => choices._id === correct._id)
          // )[0];
          // console.log(this.answer_correct, "correctIndex");
          // console.log(result.correct, "correct");
          // this.title = filterLecture.title;
          // this.description = filterLecture.description;
          // let resultLink = await getPrivateFile(filterLecture.file[0]._id);
          // this.fileName = filterLecture.file[0].title;
          // this.urlFile = resultLink;
          // this.oldFileId = filterLecture.file[0]._id;
          // this.otherFile = null
        } else {
          this.valid = true;
          this.dialog_1 = false;
          this.title = '';
          this.article = '';
          this.oldQuestion = {};
          this.$refs.form.reset();
        }
      }
    },
  },
  methods: {
    async validate() {
      this.loading = true;
      if (this.$refs.form.validate() && this.article !== '') {
        let question = {
          idexam: this.examId,
          typeQuestion: 'article',
          article: this.article,
          question: this.title,
        };
        if (this.articleId) {
          question = {
            ...question,
            articleQuestion: this.articleId,
          };
        }
        if (this.questionId) {
          let resultQuestion = await updateQuestion({
            id: this.questionId,
            ...this.oldQuestion,
            ...question,
          });
          console.log(resultQuestion);
          if (resultQuestion.code && resultQuestion.code != 200) {
            this.dialogSaveFail = true;
          } else {
            this.loading = false;
            this.dialogSuccess = true;
            this.closeDialog();
            this.clearDateValidation();
          }
        } else {
          let resultQuestion = await insertQuestion(question);
          console.log(resultQuestion);
          if (resultQuestion.code && resultQuestion.code != 200) {
            this.dialogSaveFail = true;
          } else {
            this.loading = false;
            this.dialogSuccess = true;
            this.closeDialog();
            this.clearDateValidation();
          }
        }
      } else {
        this.dialogSaveFail = true;
      }
    },

    async closeDialogQuestion() {
      let data = {
        title: this.title,
        article: this.article,
      };
      console.log('closeDialogQuestion -> data', data);
      if (JSON.stringify(this.oldQuestion) !== JSON.stringify(data)) {
        this.warnningToSaveDialog = true;
      } else {
        this.closeDialog();
        this.clearDateValidation();
      }
    },
    confirmCloseDialog() {
      this.warnningToSaveDialog = false;
      this.closeDialog();
      this.clearDateValidation();
    },
    clearDateValidation() {
      this.valid = true;
      this.dialog_1 = false;
      this.title = '';
      this.article = '';
      this.oldQuestion = {};
      this.$refs.form.reset();
    },
  },
  beforeMount() {
    this.chars = 'abcdefghijklmnopqrstuvwxyz'.split('');
  },
};
</script>
<style>
.rowContentmange {
  border-style: solid;
  border-radius: 15px;
  border-color: rgb(195, 195, 195);
  border-right-width: thin;
  border-top-width: thin;
  border-left-width: thin;
  border-bottom-width: thin;
}
.lecture-card {
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  border-radius: 15px;
  transition: transform 0.3s ease-in-out;
}
.article .editor .ql-container {
  min-height: 150px;
}
</style>
<style scoped>
.button-primary {
  background-color: rgb(66, 154, 216) !important;
  color: white;
}
</style>
